import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonLayoutModule, CommonUIBasicModule, CommonUIButtonsModule, CommonUIElementsModule, CommonUIFieldsModule, DictionaryFieldsModule, TranslationComponentsModule } from '@sdbn/common';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { TasksModule } from './../../processing/tasks/tasks.module';
import { GateKeeperControlComponent } from './gate-keeper-control/gate-keeper-control.component';
import { GKCCandidateDetailsComponent } from './gate-keeper-control/gkc-candidate-details/gkc-candidate-details.component';
import { GKCFindElementByQrCameraPickerDialogComponent } from './gate-keeper-control/gkc-find-element-dialog/gkc-camera-picker-dialog/gkc-camera-picker-dialog.component';
import { GKCFindElementByQrCameraPickerComponent } from './gate-keeper-control/gkc-find-element-dialog/gkc-camera-picker/gkc-camera-picker.component';
import { GKCFindElementByLprComponent } from './gate-keeper-control/gkc-find-element-dialog/gkc-find-element-by-lpr/gkc-find-element-by-lpr.component';
import { GKCFindElementByQrComponent } from './gate-keeper-control/gkc-find-element-dialog/gkc-find-element-by-qr/gkc-find-element-by-qr.component';
import { GKCFindElementByQueryComponent } from './gate-keeper-control/gkc-find-element-dialog/gkc-find-element-by-query/gkc-find-element-by-query.component';
import { GKCFindElementDialogComponent } from './gate-keeper-control/gkc-find-element-dialog/gkc-find-element-dialog.component';
import { GKCSelectGateDialogComponent } from './gate-keeper-control/gkc-select-gate-dialog/gkc-select-gate-dialog.component';
import { GKCSelectGateTileComponent } from './gate-keeper-control/gkc-select-gate-dialog/gkc-select-gate-tile/gkc-select-gate-tile.component';
import { FormsModule, ReactiveFormsModule  } from "@angular/forms";



@NgModule({
  declarations: [
    GateKeeperControlComponent,
    GKCFindElementDialogComponent,
    GKCCandidateDetailsComponent,
    GKCFindElementByQueryComponent,
    GKCFindElementByLprComponent,
    GKCFindElementByQrComponent,
    GKCFindElementByQrCameraPickerComponent,
    GKCFindElementByQrCameraPickerDialogComponent,
    GKCSelectGateDialogComponent,
    GKCSelectGateTileComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    CommonUIButtonsModule,
    CommonUIBasicModule,
    CommonUIElementsModule,
    TranslationComponentsModule,
    DictionaryFieldsModule,
    CommonUIFieldsModule,
    TasksModule,
    ZXingScannerModule,
    FormsModule,
    ReactiveFormsModule
],
  exports: [
    GateKeeperControlComponent,
    GKCFindElementByLprComponent
  ]
})
export class GateKeepingComponentsModule { }
